import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import {
  ICreditdDetail,
  ID_PAYMENT_AGREEMENT,
  IorganizationCommercialPreferenceDetail,
  UUID_PAYMENT_AGREEMENT
} from '../../../../types/bussines';
import { formatShortDate } from '../../../../utils/formatDatesAndHours';
import { NudosButton } from '../../../../components/NudosComponents';
import BordTextButton from '../../../../components/NudosComponents/BordTextButton/BordTextButton';

export interface IDetailCard {
  id: number;
  createdAt: string;
  document: string;
  name: string;
  stateId: number;
  credit?: ICreditdDetail;
  organizationCommercialPreferences: IorganizationCommercialPreferenceDetail[];
}
interface ICardBussines {
  dataCard: IDetailCard;
  openCreditModal: (id: number, isEdit?: boolean) => void;
}

const CardBussines: FC<ICardBussines> = ({ dataCard, openCreditModal }: ICardBussines) => {
  const { push } = useHistory();

  const goToDetails = () => push(`/organization/details/${dataCard?.id}`);

  const creditForOrderIndex = dataCard?.organizationCommercialPreferences.findIndex(
    item => item?.commercialPreferenceTypeId === ID_PAYMENT_AGREEMENT.REQUIRE_PAYMENT_AGREEMENT_FOR_ORDER
  );
  const creditForOrderValue =
    dataCard?.organizationCommercialPreferences[creditForOrderIndex]?.commercialPreferenceValue;
    const creditForServiceIndex = dataCard?.organizationCommercialPreferences.findIndex(
    item => item?.commercialPreferenceTypeId === ID_PAYMENT_AGREEMENT.REQUIRE_PAYMENT_AGREEMENT_FOR_SERVICE
  );
  const creditForServiceValue =
    dataCard?.organizationCommercialPreferences[creditForServiceIndex]?.commercialPreferenceValue;
  const deadlineOrder: number = creditForOrderValue || 0;
  const deadlineService: number = creditForServiceValue || 0;
  const delaineOrderTransform = deadlineOrder === 1 ? `${deadlineOrder} día` : `${deadlineOrder} días`;
  const delaineServiceTransform = deadlineService === 1 ? `${deadlineService} día` : `${deadlineService} días`;
  const isDataCreditActive = deadlineOrder >= 1 || deadlineService >= 1;
  return (
    <div id="cardBussines">
      <div className="boxCard">
        <div className="idContainer" onClick={goToDetails}>
          #{dataCard.id}
        </div>
        <div className="dateContainer" onClick={goToDetails}>
          {dataCard.createdAt ? formatShortDate(dataCard.createdAt)?.textWithTimezone : ''}
        </div>
        <div className="rfcContainer" onClick={goToDetails}>
          {dataCard.document}
        </div>
        <div className="nameContainer" onClick={goToDetails}>
          {dataCard.name}
        </div>
        <div className="statusContainer" onClick={goToDetails}>
          {dataCard.stateId === 1 ? (
            <div className="notApproved">Sin Aprobar</div>
          ) : dataCard.stateId === 2 ? (
            <div className="approved">Aprobado</div>
          ) : (
            <div className="refused">No Aprobado</div>
          )}
        </div>
        <div className={`creditContainer ${isDataCreditActive ? 'moreSpace' : ''}`}>
          {isDataCreditActive ? (
            <div className="infoCreditContainer">
              <div className="col1">
                <div className="infoPaymentAgree">
                  <div className="title">Órdenes</div>
                  <div className={`infoCount ${deadlineOrder <= 0 && 'inactive'}`}>
                    {delaineOrderTransform === '0 días' ? 'Inactivo' : delaineOrderTransform}
                  </div>
                </div>
                <div className="infoPaymentAgree">
                  <div className="title">Servicios</div>
                  <div className={`infoCount ${deadlineService <= 0 && 'inactive'}`}>
                    {delaineServiceTransform === '0 días' ? 'Inactivo' : delaineServiceTransform}
                  </div>
                </div>
              </div>
              <div className="col2">
                <BordTextButton
                  text="Editar"
                  onClick={() => {
                    openCreditModal(dataCard?.id, true);
                  }}
                  variantIconRight="edit"
                />
              </div>
            </div>
          ) : (
            <NudosButton
              isButtonDisabled={dataCard.stateId !== 2}
              customClassName="buttonAddCredit"
              buttonText="Agregar"
              handleClick={() => {
                openCreditModal(dataCard?.id);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CardBussines;
